import {FC, useRef, useState} from 'react'
import ReactSlider from 'react-slider'
import { site } from '../../constants/global'
import {getRegData} from "../../wordpress/operations/get-reg-data";
import {onlyDigits} from "../../lib/helpers";
import ScrollTo from "../common/ScrollTop/ScrollTo";

interface Props {
    booking?: Booking,
    setBooking: Function
}

const RepairDescription: FC<Props> = ({ booking, setBooking}) => {

    const [description, setDescription] = useState<any>(booking.repair_desc);

    const updateDescriptionField = (e: any) => {
        setDescription(e.target.value)
        booking.repair_desc = e.target.value
        setBooking({
            ...booking,
        })
    }

    return (
        <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                <div className="text-content">
                    <h2 className="required">Reparation</h2>
                    <p>Tänk på att vi kan behöva felsöka bilen vid besöket om ni exempelvis anger att felindikering
                        är tänd och att vi återkommer till er med åtgärdsförslag.</p>
                </div>
            </div>
            <div className="main-bg col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                <div className="form-content">
                    <div className="input-outer">
                        <label>
                            Beskriv vad som skall åtgärdas <abbr className="required" title="krävs">*</abbr>
                        </label>
                        <div className="registration-field">
                            <textarea id="booking-repair-desc" rows={6} name="reparation" maxLength={1000} placeholder="Max 1000 tecken" defaultValue={description} onChange={updateDescriptionField} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
};

export default RepairDescription
